import { Box, Container, Typography } from "@mui/material";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import { motion } from "framer-motion";

import ruls from "../../assets/img/ruls.jpg";

export const HeroRegla = () => {
  return (
    <>
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "#fff",
        pt: {
          xs: 8,
          md: 10,
        },
        pb: {
          xs: 8,
          md: 10,
        },
      }}
    >
      {/* Imagen */}

      <Box
        component={motion.div}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{
          duration: 8,
          ease: "easeOut",
        }}
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,

          width: {
            xs: "100%",
            md: "58%",
          },

          backgroundImage: `url(${ruls})`,
          backgroundPosition: "center",
          backgroundSize: "cover",

          opacity: .22,

          filter: "brightness(1.1)",

          clipPath: {
            xs: "none",
            md: "polygon(18% 0%,100% 0%,100% 100%,0% 100%)",
          },

          zIndex: 1,
        }}
      />

      {/* Gradiente */}

      <Box
        sx={{
          position: "absolute",
          inset: 0,

          background: `
linear-gradient(
90deg,
rgba(255,255,255,1) 0%,
rgba(255,255,255,.98) 30%,
rgba(255,255,255,.93) 50%,
rgba(255,255,255,.78) 70%,
rgba(255,255,255,.90) 100%
)
`,
          zIndex: 2,
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 5,
        }}
      >
        <Box
          component={motion.div}
          initial={{
            opacity: 0,
            y: 35,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: .8,
          }}
          sx={{
            maxWidth: 620,
          }}
        >
          {/* Icono */}

          <Box
            sx={{
              width: 72,
              height: 72,

              borderRadius: "50%",

              background: "rgba(143,21,21,.08)",

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              mb: 4,
            }}
          >
            <GavelRoundedIcon
              sx={{
                color: "#8F1515",
                fontSize: 36,
              }}
            />
          </Box>

          {/* Título */}

          <Typography
            sx={{
              fontFamily: "Archivo",
              fontWeight: 700,

              color: "#13294B",

              lineHeight: 1.05,

              fontSize: {
                xs: "2rem",
                md: "3rem",
              },
            }}
          >
            Documentos y Reglamentos
          </Typography>

          {/* Línea */}

          <Box
            component={motion.div}
            initial={{
              width: 0,
            }}
            whileInView={{
              width: 90,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              delay: .3,
              duration: .7,
            }}
            sx={{
              mt: 3,
              mb: 4,

              height: 4,

              background: "#8F1515",

              borderRadius: 20,
            }}
          />

          {/* Texto */}

          <Typography
            sx={{
              color: "#596275",
              fontFamily: "Archivo",

              fontSize: {
                xs: "1rem",
                md: "1.15rem",
              },

              lineHeight: 1.8,
            }}
          >
            En esta sección encontrarás todos los reglamentos,
            protocolos, manuales y documentos oficiales que regulan el
            funcionamiento de nuestra comunidad educativa, promoviendo
            una convivencia basada en el respeto, la inclusión y el
            compromiso institucional.
          </Typography>
        </Box>
      </Container>

      {/* Decoraciones */}

      <Box
        sx={{
          position: "absolute",

          right: -120,

          top: -120,

          width: 320,

          height: 320,

          borderRadius: "50%",

          background:
            "radial-gradient(circle,#8F151510 0%,transparent 70%)",

          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",

          left: -100,

          bottom: -120,

          width: 250,

          height: 250,

          borderRadius: "50%",

          background:
            "radial-gradient(circle,#484A7510 0%,transparent 70%)",

          zIndex: 0,
        }}
      />
     
    </Box> 
    <Box
            component="div"
            
            sx={{
              mt: 3,
              mb: 4,

              height: 2,

              background: "#eea1a1",

              borderRadius: 20,
            }}
          />
</>
  );
};